import React from 'react';
import type { DriverType, DriverBadgeProps } from '../../types';
import { DRIVER_CONFIG } from '../../types';

// Default config for unknown driver types
const DEFAULT_CONFIG = {
  color: 'text-slate-600',
  bgColor: 'bg-slate-100',
  label: 'Unknown',
};

export function DriverBadge({ driver, size = 'md' }: DriverBadgeProps) {
  const config = DRIVER_CONFIG[driver] || { ...DEFAULT_CONFIG, label: driver };

  const sizeClasses = size === 'sm'
    ? 'text-[9px] px-1 py-0.5'
    : 'text-[10px] px-1.5 py-0.5';

  return (
    <span
      className={`fv3-driver-badge font-medium rounded ${config.bgColor} ${config.color} ${sizeClasses}`}
    >
      {config.label}
    </span>
  );
}

// Helper function to get driver display name
export function getDriverDisplayName(driver: DriverType): string {
  const config = DRIVER_CONFIG[driver];
  return config?.label || driver;
}

// Helper function to categorize drivers
export function getDriverCategory(driver: DriverType): string {
  if (driver.includes('ORN') || driver.includes('ARN')) return 'Room-based';
  if (driver.includes('%') || driver.includes('Rev')) return 'Revenue-based';
  if (driver.includes('YoY') || driver.includes('LM') || driver.includes('LY')) return 'Historical';
  if (driver === 'Manual' || driver === 'Static Entry') return 'Manual';
  return 'Other';
}

export default DriverBadge;
